// React/Next imports
import { useRouter } from 'next/router';

// Hooks
import useUser from '@/utils/hooks/swr/useUser';

// Utils
import useDarkMode from '@/utils/hooks/utils/useDarkMode';

// Components
import LoaderPage from '@/components/base/Loader/LoaderPage';
import type { WrapperPlatformProps } from '@/components/layouts/wrappers/WrapperPlatform';
import { WrapperPlatform } from '@/components/layouts/wrappers/WrapperPlatform';

type WrapperSwitchLayoutProps = Pick<WrapperPlatformProps, 'noPadding' | 'disableMainScroll'> & {
    className?: string;
    bodyWrapperClass?: string;
    children: React.ReactNode;
};

export function WrapperSwitchLayout({
    noPadding = false,
    disableMainScroll = false,
    className,
    children
}: WrapperSwitchLayoutProps) {
    const router = useRouter();
    const { isLoading, userError } = useUser();
    const { useAddDarkMode } = useDarkMode();
    useAddDarkMode();

    if (userError || isLoading) {
        if (userError) {
            router.push('/');
        }

        return <LoaderPage />;
    }

    return (
        <WrapperPlatform
            className={className}
            noPadding={noPadding}
            disableMainScroll={disableMainScroll}>
            {children}
        </WrapperPlatform>
    );
}
